// /mnt/data/Home.js  (updated)
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import { useSelector, useDispatch } from 'react-redux';
import {
  TextField,
  Box,
  Button,
  useMediaQuery,
  Typography,
  Divider,
  IconButton,
} from '@mui/material';
import { lightTheme, darkTheme } from '../themes/themes';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import axios from 'axios';
import CoinSlider from '../Components/HomeComponents/CoinSlider';
import TopNav from '../Components/NavComponents/TopNav';
import BottomNav from '../Components/NavComponents/BottomNav';
import './Home.css';
import MarketTable from '../Components/HomeComponents/MarketTalble';
import VolumeUp from '@mui/icons-material/VolumeUp';
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';
import PsychologyAltOutlinedIcon from '@mui/icons-material/PsychologyAltOutlined';
// ⬇️ NEW: promote icon
import CampaignIcon from '@mui/icons-material/Campaign';
import SlidingNotifications from '../Components/HomeComponents/SlidingNotification'
import invite from './invite.png';
import promote from './promote.png'

import { fetchNotifications } from '../store/Slices/NotificationSlice';
import BalanceSection from './BalanceSection';

const Home = () => {
  const theme = useTheme();
  const isLightTheme = useSelector((state) => state.theme.light);
  const navigate = useNavigate();
  const [allCoins, setAllCoins] = useState([]);
  const [errorCoins, setErrorCoins] = useState(null);
  const [news, setNews] = useState([]);
  const [newsIndex, setNewsIndex] = useState(0);
  const [navValue, setNavValue] = useState(0);
  const isMobile = useMediaQuery('(max-width:600px)');
  const user = useSelector((state) => state.user.data);
  const dispatch = useDispatch();

  // ⬇️ NEW: Centralized slides (3 images, each with its own route)
  // Change `to` values to the exact paths you want.
  const promoSlides = [
    { src: invite, alt: 'Trade Now', to: '/referral' },
    { src: promote, alt: 'Create & Earn', to: '/promote-earn' },
  ];

  const imageSliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  const handleNextNews = () => {
    setNewsIndex((prev) => (prev + 1) % news.length);
  };


  const MobileView = () => (
    <>
      <TopNav isMobile={isMobile} />
      <Box
        sx={{
          pt: 8,
          pb: 10,
          bgcolor: theme.palette.background.default,
          minHeight: '100vh',
          color: theme.palette.text.primary,
        }}
      >
        <Box sx={{ px: 2, mb: 2 }}>
          <BalanceSection />
        </Box>

        <CoinSlider isMobile={isMobile} />

        <Box sx={{ py: 1, mb: 2 }}>
          <SlidingNotifications />
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-around', mb: 2 }}>
          <Button
            sx={{
              color: theme.palette.text.primary,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
            onClick={() => navigate('/deposit')}
          >
            <CurrencyExchangeIcon sx={{ fontSize: 35, color: theme.palette.brand.main }} />
            <Typography variant="caption">Deposit</Typography>
          </Button>

          <Button
            sx={{
              color: theme.palette.text.primary,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
            onClick={() => navigate('/luck-wheel')}
          >
            <SavingsOutlinedIcon sx={{ fontSize: 35, color: theme.palette.brand.main }} />
            <Typography variant="caption">Earn</Typography>
          </Button>

          <Button
            sx={{
              color: theme.palette.text.primary,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
            onClick={() => navigate('/ai-trading')}
          >
            <PsychologyAltOutlinedIcon sx={{ fontSize: 35, color: theme.palette.brand.main }} />
            <Typography variant="caption">AI Trade</Typography>
          </Button>

          {/* ⬇️ UPDATED: Promote button (was "More") */}
          <Button
            sx={{
              color: theme.palette.text.primary,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
            onClick={() =>
              user?.role === 'Support'
                ? navigate('/promote-earn/review')
                : navigate('/promote-earn')
            }
          >
            <CampaignIcon sx={{ fontSize: 35, color: theme.palette.brand.main }} />
            <Typography variant="caption">Promote</Typography>
          </Button>
        </Box>

        {/* ⬇️ UPDATED: 3 clickable slides with per-slide navigation */}
        <Box sx={{ px: 2, mb: 2 }}>
          <Slider {...imageSliderSettings}>
            {promoSlides.map((slide, idx) => (
              <Box key={idx} onClick={() => navigate(slide.to)} sx={{ cursor: 'pointer' }}>
                <img
                  src={slide.src}
                  alt={slide.alt}
                  style={{ width: '100%', borderRadius: '8px', display: 'block' }}
                />
              </Box>
            ))}
          </Slider>
        </Box>

        <Box sx={{ px: 2 }}>
          <MarketTable />
        </Box>
      </Box>
      <BottomNav navValue={navValue} setNavValue={setNavValue} />
    </>
  );

  const DesktopView = () => (
    <>
      <TopNav isMobile={isMobile} />
      <Box
        sx={{
          pt: 10,
          bgcolor: theme.palette.background.default,
          minHeight: '100vh',
          px: 4,
          color: theme.palette.text.primary,
        }}
      >
        <Box sx={{ maxWidth: 1200, mx: 'auto', mb: 4 }}>
          <BalanceSection />
        </Box>

        <Box sx={{ mb: 4 }}>
          <CoinSlider isMobile={isMobile} />
        </Box>

        <Box sx={{ py: 1, mb: 2 }}>
          <SlidingNotifications />
        </Box>

        <Box sx={{ display: 'flex', gap: 2, mb: 4, justifyContent: 'center' }}>
          <Button
            sx={{
              color: theme.palette.text.primary,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
            onClick={() => navigate('/deposit')}
          >
            <CurrencyExchangeIcon sx={{ fontSize: 40, color: theme.palette.brand.main }} />
            <Typography variant="caption">Deposit</Typography>
          </Button>

          <Button
            sx={{
              color: theme.palette.text.primary,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
            onClick={() => navigate('/luck-wheel')}
          >
            <SavingsOutlinedIcon sx={{ fontSize: 40, color: theme.palette.brand.main }} />
            <Typography variant="caption">Earn</Typography>
          </Button>

          <Button
            sx={{
              color: theme.palette.text.primary,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
            onClick={() => navigate('/ai-trading')}
          >
            <PsychologyAltOutlinedIcon sx={{ fontSize: 40, color: theme.palette.brand.main }} />
            <Typography variant="caption">AI Trade</Typography>
          </Button>

          {/* ⬇️ UPDATED: Promote button (kept role-based routing) */}
          <Button
            sx={{
              color: theme.palette.text.primary,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
            onClick={() =>
              user?.role === 'Support'
                ? navigate('/promote-earn/review')
                : navigate('/promote-earn')
            }
          >
            <CampaignIcon sx={{ fontSize: 40, color: theme.palette.brand.main }} />
            <Typography variant="caption">Promote</Typography>
          </Button>
        </Box>

        {/* ⬇️ UPDATED: 3 clickable slides on desktop too */}
        <Box sx={{ mb: 4, maxWidth: 700, mx: 'auto' }}>
          <Slider {...imageSliderSettings}>
            {promoSlides.map((slide, idx) => (
              <Box key={idx} onClick={() => navigate(slide.to)} sx={{ cursor: 'pointer' }}>
                <img
                  src={slide.src}
                  alt={slide.alt}
                  style={{ width: '100%', borderRadius: '8px', display: 'block' }}
                />
              </Box>
            ))}
          </Slider>
        </Box>

        <Box>
          <MarketTable />
        </Box>
      </Box>
    </>
  );

  return (
    <ThemeProvider theme={isLightTheme ? lightTheme : darkTheme}>
      {isMobile ? <MobileView /> : <DesktopView />}
    </ThemeProvider>
  );
};

export default Home;
